import type { Bill } from '../billing/billing.interface';
import { BILL_LINE_KEYS } from '../billing/billing.interface';
import { baseDocumentFactory } from './base-document.factory';
import { ObjectFactory } from './object.factory';

export class BillFactory extends ObjectFactory<Bill> {
  protected getDefaults(): Bill {
    return {
      ...baseDocumentFactory.build(),
      billingPeriod: { month: 9, year: 2026 },
      computedAt: new Date('2026-10-01T00:00:00.000Z'),
      currency: 'EUR',
      lines: [{ amount: 99, key: BILL_LINE_KEYS.MONTHLY_FEE }],
      locked: false,
      metrics: { activeVehicleCount: 0, taskCount: 0, vehicleActivityDays: 0 },
      planName: 'standard',
      total: 99,
      violations: [],
    };
  }
}

export const billFactory = new BillFactory();
